import React, { useState, useEffect } from 'react';
import { Modal, Box, Typography, TextField, Button } from '@mui/material';
import Swal from 'sweetalert2';
import api from '../services/api';

const SupportModal = ({ open, onClose, support, onSave, fetchData }) => {
  const [email, setEmail] = useState('');
  const [wpp, setWpp] = useState('');
  const [sites, setSites] = useState('');
  const [phone, setPhone] = useState('');

  useEffect(() => {
    if (support) {
      setEmail(support.email);
      setWpp(support.wpp);
      setSites(support.sites);
      setPhone(support.phone);
    } else {
      setEmail('');
      setWpp('');
      setSites('');
      setPhone('');
    }
  }, [support]);

  const handleSave = async () => {
    try {
      const newSupport = { email, wpp, sites, phone };

      if (support && support.id) {
        await api.put(`/suportt/update-support-email/${support.id}`, { email: newSupport.email });
        await api.put(`/suportt/update-support-wpp/${support.id}`, { wpp: newSupport.wpp });
        await api.put(`/suportt/update-support-sites/${support.id}`, { sites: newSupport.sites });
        await api.put(`/suportt/update-support-phone/${support.id}`, { phone: newSupport.phone });
      } else {
        await api.post('/suportt/create-support', newSupport);
      }

      onSave();
      onClose();
      Swal.fire('Sucesso!', 'Suporte salvo com sucesso.', 'success');
      fetchData();
    } catch (error) {
      Swal.fire('Erro!', 'Falha ao salvar o suporte.', 'error');
    }
  };

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="modal-title" aria-describedby="modal-description">
      <Box sx={{ width: 300, padding: 2, margin: 'auto', marginTop: '10%', bgcolor: 'background.paper', boxShadow: 24, p: 4 }}>
        <Typography id="modal-title" variant="h6" gutterBottom>{support ? 'Editar Suporte' : 'Adicionar Suporte'}</Typography>
        <TextField
          label="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="WhatsApp"
          value={wpp}
          onChange={(e) => setWpp(e.target.value)}
          fullWidth
          margin="normal"
          inputProps={{ maxLength: 13 }}
        />
        <TextField
          label="Sites"
          value={sites}
          onChange={(e) => setSites(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Telefone"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          fullWidth
          margin="normal"
          inputProps={{ maxLength: 13 }}
        />
        <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 2 }}>
          <Button onClick={onClose}>Cancelar</Button>
          <Button onClick={handleSave} variant="contained">Salvar</Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default SupportModal;
